import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import FormEditaEmpresa from './FormEditaEmpresa';
import { InputText } from 'primereact/inputtext';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Checkbox } from "primereact/checkbox";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

export default function SidebarParametrosIntegracao(props) {
    const [openSideBarParametros, setOpenSidebarParametros] = useState(false)
    const [empresa, setEmpresa] = useState({ ...props.empresa });

    const [isChecked1, setIsChecked1] = useState(false); // Estado do switch para a primeira aba
    const [isChecked2, setIsChecked2] = useState(false); // Estado do switch para a segunda aba

    const [parametrosIntegracao, setParametrosIntegracao] = useState({
        idempresa : props.empresa.idempresa,
        idusuario : props.empresa.idusuario,
        codigoEmpresa : props.empresa.codemp,
        operacaoRequisicao : props.empresa.operacao ? props.empresa.operacao : 1 ,
        tipoDescRequisicao : props.empresa.tipodesc,
        statusRequisicao : props.empresa.status,
        situacaoRequisicao : props.empresa.situacao,
        condicaoPagamentoRequisicao :props.empresa.condpag ,
        vendedorRequisicao : props.empresa.vend,
        tecnicoChamado : props.empresa.codtec,
        motivoChamado : "C",
        tipoIntervencaoChamado : "I",
        statusChamado : props.empresa.statusos,
        operadorChamado : "DATACOUNT",
        habilitarIntegracao : props.empresa.habilitarintegracao,
        habilitarIntegracaoEmailRequisicao : props.empresa.habilitarintegracaoemailrequisicao,
        habilitarIntegracaoEmailOrdemServico : props.empresa.habilitarintegracaoemailordemservico,
        habilitarIntegracaoContadores : props.empresa.habilitarintegracaocontadores,
        habilitarIntegrarRequisicoes : props.empresa.habilitarintegrarrequisicoes,
        habilitarIntegrarOrdensServico : props.empresa.habilitarintegrarordensservico,
        importarChamadasServico : props.empresa.importarchamadasservico,
        importarAlertasConsumiveis : props.empresa.importaralertasconsumiveis,
        importarAtolamentos : props.empresa.importaratolamentos,
        diasAtolamentos : props.empresa.diasatolamentos,
        importarAlertasDiversos : props.empresa.importaralertasdiversos,
        tonerEmpty : props.empresa.tonerempty,
        tonerAlmostEmpty : props.empresa.toneralmostempty,
        wasteTonerReceptacleAlmostFull : props.empresa.wastetonerreceptaclealmostfull,
        wasteInkReceptacleFull : props.empresa.wasteinkreceptaclefull,
        developerAlmostEmpty : props.empresa.developeralmostempty,
        inkEmpty : props.empresa.inkempty,
        inkAlmostEmpty : props.empresa.inkalmostempty,
        wasteInkReceptacleAlmostFull : props.empresa.wasteinkreceptaclealmostfull,
        opcLifeAlmostOver : props.empresa.opclifealmostover,
        developerEmpty : props.empresa.developerempty,
        printRibbonEmpty : props.empresa.printribbonempty,
        printRibbonAlmostEmpty : props.empresa.printribbonalmostempty,
        wasteTonerReceptacleFull : props.empresa.wastetonerreceptaclefull,
        opcLifeOver : props.empresa.opclifeover,
        markerSupplies : props.empresa.markersupplies,
        emailNotificacaoChamado : props.empresa.emailnotificaocaochamado,
        emailNotificacaoToner : props.empresa.emailnotificacaorequisicao
    })

    useEffect(() => {
        setEmpresa({ ...props.empresa });
        setParametrosIntegracao({
        idempresa : props.empresa.idempresa,
        idusuario : props.empresa.idusuario,
        codigoEmpresa : props.empresa.codemp,
        operacaoRequisicao : props.empresa.operacao,
        tipoDescRequisicao : props.empresa.tipodesc,
        statusRequisicao : props.empresa.status,
        situacaoRequisicao : props.empresa.situacao,
        condicaoPagamentoRequisicao :props.empresa.condpag ,
        vendedorRequisicao : props.empresa.vend,
        tecnicoChamado : props.empresa.codtec,
        motivoChamado : "C",
        tipoIntervencaoChamado : "I",
        statusChamado : props.empresa.statusos,
        operadorChamado : "DATACOUNT",
        habilitarIntegracao : props.empresa.habilitarintegracao,
        habilitarIntegracaoEmailRequisicao : props.empresa.habilitarintegracaoemailrequisicao,
        habilitarIntegracaoEmailOrdemServico : props.empresa.habilitarintegracaoemailordemservico,
        habilitarIntegracaoContadores : props.empresa.habilitarintegracaocontadores,
        habilitarIntegrarRequisicoes : props.empresa.habilitarintegrarrequisicoes,
        habilitarIntegrarOrdensServico : props.empresa.habilitarintegrarordensservico,
        importarChamadasServico : props.empresa.importarchamadasservico,
        importarAlertasConsumiveis : props.empresa.importaralertasconsumiveis,
        importarAtolamentos : props.empresa.importaratolamentos,
        diasAtolamentos : props.empresa.diasatolamentos,
        importarAlertasDiversos : props.empresa.importaralertasdiversos,
        tonerEmpty : props.empresa.tonerempty,
        tonerAlmostEmpty : props.empresa.toneralmostempty,
        wasteTonerReceptacleAlmostFull : props.empresa.wastetonerreceptaclealmostfull,
        wasteInkReceptacleFull : props.empresa.wasteinkreceptaclefull,
        developerAlmostEmpty : props.empresa.developeralmostempty,
        inkEmpty : props.empresa.inkempty,
        inkAlmostEmpty : props.empresa.inkalmostempty,
        wasteInkReceptacleAlmostFull : props.empresa.wasteinkreceptaclealmostfull,
        opcLifeAlmostOver : props.empresa.opclifealmostover,
        developerEmpty : props.empresa.developerempty,
        printRibbonEmpty : props.empresa.printribbonempty,
        printRibbonAlmostEmpty : props.empresa.printribbonalmostempty,
        wasteTonerReceptacleFull : props.empresa.wastetonerreceptaclefull,
        opcLifeOver : props.empresa.opclifeover,
        markerSupplies : props.empresa.markersupplies,
        emailNotificacaoChamado : props.empresa.emailnotificaocaochamado,
        emailNotificacaoToner : props.empresa.emailnotificacaorequisicao
        })
    }, [props.empresa]);



    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">Revenda: {empresa.razaosocial}</span>
        </div>
    );

     const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };

    const toast = React.useRef(null); // Ref para o Toast

    const updateParametrosIntegracaoEmpresa = () =>{
        //empresasController/updateParametrosIntegracaoEmpresa
        props.Conexao.post('empresasController/updateParametrosIntegracaoEmpresa', {
                idempresa : parametrosIntegracao.idempresa,
                idusuario : parametrosIntegracao.idusuario,
                codigoEmpresa : parametrosIntegracao.codigoEmpresa,
                operacaoRequisicao : parametrosIntegracao.operacaoRequisicao,
                tipoDescRequisicao : parametrosIntegracao.tipoDescRequisicao,
                statusRequisicao : parametrosIntegracao.statusRequisicao,
                situacaoRequisicao : parametrosIntegracao.situacaoRequisicao,
                condicaoPagamentoRequisicao :parametrosIntegracao.condicaoPagamentoRequisicao ,
                vendedorRequisicao : parametrosIntegracao.vendedorRequisicao,
                tecnicoChamado : parametrosIntegracao.tecnicoChamado,
                motivoChamado : "C",
                tipoIntervencaoChamado : "I",
                statusChamado : parametrosIntegracao.statusChamado,
                operadorChamado : "DATACOUNT",
                habilitarIntegracao : parametrosIntegracao.habilitarIntegracao,
                habilitarIntegracaoEmailRequisicao : parametrosIntegracao.habilitarIntegracaoEmailRequisicao,
                habilitarIntegracaoEmailOrdemServico : parametrosIntegracao.habilitarIntegracaoEmailOrdemServico,
                habilitarIntegracaoContadores : parametrosIntegracao.habilitarIntegracaoContadores,
                habilitarIntegrarRequisicoes : parametrosIntegracao.habilitarIntegrarRequisicoes,
                habilitarIntegrarOrdensServico : parametrosIntegracao.habilitarIntegrarOrdensServico,
                importarChamadasServico : parametrosIntegracao.importarChamadasServico,
                importarAlertasConsumiveis : parametrosIntegracao.importarAlertasConsumiveis,
                importarAtolamentos : parametrosIntegracao.importarAtolamentos,
                diasAtolamentos : parametrosIntegracao.diasAtolamentos,
                importarAlertasDiversos : parametrosIntegracao.importarAlertasDiversos,
                tonerEmpty : parametrosIntegracao.tonerEmpty,
                tonerAlmostEmpty : parametrosIntegracao.tonerAlmostEmpty,
                wasteTonerReceptacleAlmostFull : parametrosIntegracao.wasteTonerReceptacleAlmostFull,
                wasteInkReceptacleFull : parametrosIntegracao.wasteInkReceptacleFull,
                developerAlmostEmpty : parametrosIntegracao.developerAlmostEmpty,
                inkEmpty : parametrosIntegracao.inkEmpty,
                inkAlmostEmpty : parametrosIntegracao.inkAlmostEmpty,
                wasteInkReceptacleAlmostFull : parametrosIntegracao.wasteInkReceptacleAlmostFull,
                opcLifeAlmostOver : parametrosIntegracao.opcLifeAlmostOver,
                developerEmpty : parametrosIntegracao.developerEmpty,
                printRibbonEmpty : parametrosIntegracao.printRibbonEmpty,
                printRibbonAlmostEmpty : parametrosIntegracao.printRibbonAlmostEmpty,
                wasteTonerReceptacleFull : parametrosIntegracao.wasteTonerReceptacleFull,
                opcLifeOver : parametrosIntegracao.opcLifeOver,
                markerSupplies : parametrosIntegracao.markerSupplies,
                emailNotificacaoChamado : parametrosIntegracao.emailNotificacaoChamado,
                emailNotificacaoToner : parametrosIntegracao.emailNotificacaoToner
        }).then(response =>{
            if(response.status === 200 && response.data.status === 'OK'){
                showMessageToast('success', "Parametros atualizados com sucesso!")
                
                setTimeout(()=>{
                    
                    setOpenSidebarParametros(false)
                    props.setDataEmpresas(parametrosIntegracao)
                }, 1500)
            }else{
                showMessageToast('warn', "Não foi possível atualizar")
            }
        }).catch(error =>{
            showMessageToast('danger', "Não foi possível atualizar!")
        })
    }

    return (
        <>
        <Button label="Integração" icon="pi pi-cog" className="p-button-primary w-full"  size="large" onClick={()=>setOpenSidebarParametros(true)} />
        <Sidebar id='SidebarParametrosIntegracao' 
            header={customHeader} visible={openSideBarParametros}  
            style={{ minWidth: '50%' }} 
            onHide={(e) => {
                if (e?.originalEvent?.key !== "Escape") {
                    setOpenSidebarParametros(false);
                }
            }}
            blockScroll={true}
            position="right" {...props}>
            <div style={{paddingTop : '10px', paddingLeft : '20px', paddingRight : '25px'}}>
            <Divider />
            <div className="flex justify-content-between align-items-center mb-4">
                <span className="font-medium text-lg">Habilitar integração com Dataclassic</span>
                <InputSwitch                   
                   checked = {parametrosIntegracao.habilitarIntegracao == 't'}
                   onChange={() => {
                       setParametrosIntegracao(prev => ({ ...prev, habilitarIntegracao: parametrosIntegracao.habilitarIntegracao === 't' ? 'f' : 't' }))
                   }}
                />
            </div>
            <div className="grid mt-2">
                <div className="col-12 md:col-3">
                    <label htmlFor="cep">Código Empresa</label>
                    <InputText
                        name="cep"
                            disabled ={parametrosIntegracao.habilitarIntegracao === 'f'}
                        className="w-full mt-2"
                        value={parametrosIntegracao.codigoEmpresa}
                        onChange={(e)=>{
                            setParametrosIntegracao(prevData => ({
                                ...prevData,
                                codigoEmpresa : e.target.value
                            }))}}
                        
                    />
                       
                </div>
                <div className="col-12 md:col-5">
                    <label htmlFor="cep">Operador</label>
                    <InputText
                        disabled ={parametrosIntegracao.habilitarIntegracao === 'f'}
                        name="cep"
                        className="w-full mt-2"
                        value={parametrosIntegracao.operadorChamado}
                    />
                       
                </div>
                <div className="col-12 md:col-4">
                    <label htmlFor="cep">Datacount</label>
                    <InputText
                        disabled ={parametrosIntegracao.habilitarIntegracao === 'f'}
                        name="cep"
                        className="w-full mt-2"
                        value={parametrosIntegracao.idusuario}

                    />
                       
                </div>
            </div>
            <br/>
            <div className="flex justify-content-between align-items-center mb-2">
                <span className="font-small">Habilitar atualização contadores</span>
                <InputSwitch
                   checked = {parametrosIntegracao.habilitarIntegracaoContadores === 't'}
                   disabled ={parametrosIntegracao.habilitarIntegracao === 'f'}
                    onChange={() => {
                        setParametrosIntegracao(prev => ({ ...prev, habilitarIntegracaoContadores: parametrosIntegracao.habilitarIntegracaoContadores === 't' ? 'f' : 't' }))
                    }}
                />
            </div>
            <br/>
     
            
            <Accordion activeIndex={-1}>
                <AccordionTab 
                    
                    header={
                  
                        <div className="flex justify-content-between align-items-center" >
                            <span className="font-medium text-lg">Integração Suprimentos</span>
                           
                        </div>
                    }>
                        <div style={{paddingLeft : '10px', paddingRight : '10px'}}>
                            <div className="flex justify-content-between align-items-center mb-2">
                                    <span className="font-small" style={{fontWeight:'bold'}}>Habilitar Integração de níveis de Suprimento</span>
                                    <InputSwitch
                                        checked = {parametrosIntegracao.habilitarIntegrarRequisicoes === 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            if(parametrosIntegracao.habilitarIntegracao === 'f'){
                                                return
                                            }
                                            setParametrosIntegracao(prev => ({ ...prev, habilitarIntegrarRequisicoes: parametrosIntegracao.habilitarIntegrarRequisicoes === 't' ? 'f' : 't' }))
                                        }}
                                    />
                            </div>
                        </div> 

                        <div style={{paddingLeft : '10px', paddingRight : '10px', marginTop : '10px'}}>
                            <div className="flex justify-content-between align-items-center mb-2">
                                    <span className="font-small">Apenas enviar email</span>
                                    <InputSwitch
                                         disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked = {parametrosIntegracao.habilitarIntegracaoEmailRequisicao === 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, habilitarIntegracaoEmailRequisicao: parametrosIntegracao.habilitarIntegracaoEmailRequisicao === 't' ? 'f' : 't' }))
                                        }}
                                    />
                            </div>
                        </div> 
                        <div className="grid mt-2">
                            <div className="col-12 md:col-12">
                                <label htmlFor="cep" className="font-small">Email de notificação</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.emailNotificacaoToner}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            emailNotificacaoToner : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                        </div>  

                        <div className="grid mt-2">
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Operação</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.operacaoRequisicao}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            operacaoRequisicao : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Tipo Desc</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.tipoDescRequisicao}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            tipoDescRequisicao : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Status</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.statusRequisicao}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            statusRequisicao : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Situação</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.situacaoRequisicao}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            situacaoRequisicao : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Cond Pag</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.condicaoPagamentoRequisicao}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            condicaoPagamentoRequisicao : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Vendedor</label>
                                <InputText
                                    name="cep"
                                     disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.vendedorRequisicao}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            vendedorRequisicao : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                        </div>        
                </AccordionTab>                   
            </Accordion>
       
           
            <Accordion activeIndex={-1} >
                <AccordionTab 
                    
                    header={
                        <div className="flex justify-content-between align-items-center " >
                        <span className="font-medium text-lg">Integração Ordens Serviço</span>
                       
                </div>
                }>
                        <div style={{paddingLeft : '10px', paddingRight : '10px'}}>
                            <div className="flex justify-content-between align-items-center mb-2">
                                    <span className="font-small" style={{fontWeight:'bold'}}>Habilitar Integração de Ordens de Serviço</span>
                                    <InputSwitch
                                        checked = {parametrosIntegracao.habilitarIntegrarOrdensServico === 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            if(parametrosIntegracao.habilitarIntegracao === 'f'){
                                                return
                                            }
                                            setParametrosIntegracao(prev => ({ ...prev, habilitarIntegrarOrdensServico: parametrosIntegracao.habilitarIntegrarOrdensServico === 't' ? 'f' : 't' }))
                                        }}
                                    />
                            </div>
                        </div> 
                        <div style={{paddingLeft : '10px', paddingRight : '10px'}}>
                            <div className="flex justify-content-between align-items-center mb-2">
                                    <span className="font-small">Apenas enviar email</span>
                                    <InputSwitch
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                         checked = {parametrosIntegracao.habilitarIntegracaoEmailOrdemServico === 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, habilitarIntegracaoEmailOrdemServico: parametrosIntegracao.habilitarIntegracaoEmailOrdemServico === 't' ? 'f' : 't' }))
                                        }}
                                    />
                            </div>
                        </div> 
                        <div className="grid mt-2">
                            <div className="col-12 md:col-12">
                                <label htmlFor="cep" className="font-small">Email de notificação</label>
                                <InputText
                                    name="cep"
                                    disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.emailNotificacaoChamado}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            emailNotificacaoChamado : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                        </div>  

                        <div className="grid mt-2">
                            <div className="col-12 md:col-3">
                                <label htmlFor="cep" className="font-small">Código Técnico</label>
                                <InputText
                                    name="cep"
                                    disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.tecnicoChamado}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            tecnicoChamado : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Motivo</label>
                                <InputText
                                    name="cep"
                                    disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.motivoChamado}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            motivoChamado : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-3">
                                <label htmlFor="cep" className="font-small">Tipo Intervenção</label>
                                <InputText
                                    name="cep"
                                    disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.tipoIntervencaoChamado}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            tipoIntervencaoChamado : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            <div className="col-12 md:col-2">
                                <label htmlFor="cep" className="font-small">Status</label>
                                <InputText
                                    name="cep"
                                    disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                    value={parametrosIntegracao.statusChamado}
                                    onChange={(e)=>{
                                        setParametrosIntegracao(prevData => ({
                                            ...prevData,
                                            statusChamado : e.target.value
                                        }))}}
                                    className="w-full mt-2"/>                                
                            </div>
                            
                        </div> 

                         <div style={{paddingLeft : '0px', paddingRight : '0px', marginTop : '20px'}}>
                            <div className="flex justify-content-between align-items-center mb-1">
                                    <span className="font-small">Importar Alertas de Consumíveis (Cilindros, fusores, laser, kit manutenção)?</span>
                                    <InputSwitch
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.importarAlertasConsumiveis}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, importarAlertasConsumiveis: prev.importarAlertasConsumiveis === 't' ? 'f' : 't' }))
                                        }}
                                    />
                            </div>

                            <div className="grid grid-cols-1 gap-3 p-1" >
                                <div className='col-12 md:col-3'>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient1" name="pizza" value="Cheese"
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.tonerEmpty  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, tonerEmpty: prev.tonerEmpty === 't' ? 'f' : 't' }))
                                        }}
                                         />
                                        <label htmlFor="ingredient1" className="ml-2" style={{fontSize : '11px'}}>TonerEmpty(1101)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient2" name="pizza" value="Mushroom" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.inkEmpty  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, inkEmpty: prev.inkEmpty === 't' ? 'f' : 't' }))
                                        }} />
                                        <label htmlFor="ingredient2" className="ml-2" style={{fontSize : '11px'}}>InkEmpty(1102)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient3" name="pizza" value="Pepper" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.printRibbonEmpty  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, printRibbonEmpty: prev.printRibbonEmpty === 't' ? 'f' : 't' }))
                                        }} />
                                        <label htmlFor="ingredient3" className="ml-2" style={{fontSize : '11px'}}>PrintRibbonEmpty(1103)</label>
                                    </div>
                                </div>
                                <div className='col-12 md:col-3'>
                                    
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient4" name="pizza" value="Onion" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.tonerAlmostEmpty  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, tonerAlmostEmpty: prev.tonerAlmostEmpty === 't' ? 'f' : 't' }))
                                        }} />
                                        <label htmlFor="ingredient4" className="ml-2" style={{fontSize : '11px'}}>TonerAlmostEmpty(1104)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient1" name="pizza" value="Cheese" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.inkAlmostEmpty  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, inkAlmostEmpty: prev.inkAlmostEmpty === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient1" className="ml-2 font-small" style={{fontSize : '11px'}}>InkAlmostEmpty(1105)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient2" name="pizza" value="Mushroom" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.printRibbonAlmostEmpty  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, printRibbonAlmostEmpty: prev.printRibbonAlmostEmpty === 't' ? 'f' : 't' }))
                                        }} />
                                        <label htmlFor="ingredient2" className="ml-2" style={{fontSize : '11px'}}>PrintRibbonAlmostEmpty(1106)</label>
                                    </div>
                                </div>
                                <div  className='col-12 md:col-4'>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient3" name="pizza" value="Pepper" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.wasteTonerReceptacleAlmostFull  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, wasteTonerReceptacleAlmostFull: prev.wasteTonerReceptacleAlmostFull === 't' ? 'f' : 't' }))
                                        }} />
                                        <label htmlFor="ingredient3" className="ml-2" style={{fontSize : '11px'}}>WasteTonerReceptacleAlmostFull(1107)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient4" name="pizza" value="Onion"  
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.wasteInkReceptacleAlmostFull  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, wasteInkReceptacleAlmostFull: prev.wasteInkReceptacleAlmostFull === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient4" className="ml-2" style={{fontSize : '11px'}}>WasteInkReceptacleAlmostFull(1108)</label>
                                    </div>
    
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient1" name="pizza" value="Cheese" 
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        checked={parametrosIntegracao.wasteTonerReceptacleFull  == 't'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, wasteTonerReceptacleFull: prev.wasteTonerReceptacleFull === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient1" className="ml-2 font-small" style={{fontSize : '11px'}}>WasteTonerReceptacleFull(1109)</label>
                                    </div>
                                   
                                </div>
                                <div className='col-12 md:col-3'>
                                    <div className="flex align-items-center" >
                                        <Checkbox inputId="ingredient2" name="pizza" value="Mushroom"  
                                        checked={parametrosIntegracao.wasteInkReceptacleFull  == 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, wasteInkReceptacleFull: prev.wasteInkReceptacleFull === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient2" className="ml-2" style={{fontSize : '11px'}}>WasteInkReceptacleFull(1110)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient3" name="pizza" value="Pepper" 
                                        checked={parametrosIntegracao.opcLifeAlmostOver  == 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, opcLifeAlmostOver: prev.opcLifeAlmostOver === 't' ? 'f' : 't' }))
                                        }} />
                                        <label htmlFor="ingredient3" className="ml-2" style={{fontSize : '11px'}}>OpcLifeAlmostOver(1111)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient4" name="pizza" value="Onion"  
                                        checked={parametrosIntegracao.opcLifeOver  == 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, opcLifeOver: prev.opcLifeOver === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient4" className="ml-2" style={{fontSize : '11px'}}>OpcLifeOver(1112)</label>
                                    </div>
                                </div>
                            
                                <div className='col-12 md:col-3'>
                                    <div className="flex align-items-center" >
                                        <Checkbox inputId="ingredient1" name="pizza" value="Cheese" 
                                        checked={parametrosIntegracao.developerAlmostEmpty  == 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, developerAlmostEmpty: prev.developerAlmostEmpty === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient1" className="ml-2 font-small" style={{fontSize : '11px'}}>DeveloperAlmostEmpty(1113)</label>
                                    </div>
                                    <div className="flex align-items-center" style={{marginTop : '5px'}}>
                                        <Checkbox inputId="ingredient2" name="pizza" value="Mushroom"  
                                        checked={parametrosIntegracao.developerEmpty  == 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, developerEmpty: prev.developerEmpty === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient2" className="ml-2" style={{fontSize : '11px'}}>DeveloperEmpty(1114)</label>
                                    </div>
                                </div>
                                <div className='col-12 md:col-3'>
                                    <div className="flex align-items-center" >
                                        <Checkbox inputId="ingredient3" name="pizza" value="Pepper"  
                                        checked={parametrosIntegracao.markerSupplies == 't'}
                                        disabled ={parametrosIntegracao.habilitarIntegrarOrdensServico === 'f' || parametrosIntegracao.habilitarIntegracao === 'f'}
                                        onChange={() => {
                                            setParametrosIntegracao(prev => ({ ...prev, markerSupplies: prev.markerSupplies === 't' ? 'f' : 't' }))
                                        }}/>
                                        <label htmlFor="ingredient3" className="ml-2" style={{fontSize : '11px'}}>markerSupplies(13)</label>
                                    </div>
                                </div>
                            </div>


                        </div> 

                        
                </AccordionTab>                   
            </Accordion>
            <div className="mt-4 flex justify-content-end mt-2">
                <Button className="mt-2 mr-2"
                    disabled={props.loading} 
                    severity="secondary" 
                    onClick={()=>setOpenSidebarParametros(false)}
                    label="Cancelar" 
                    icon="pi pi-times"
                />
                <Button className="mt-2 mr-2"
                    disabled={props.loading} 
                    severity="primary" 
                    onClick={()=>{
                         confirmDialog({
                                message: 'Confirma confirmar a gravação dos parametros informados?',
                                header: 'Confirmação',
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: 'Sim',
                                rejectLabel: 'Não',
                                accept: () => {
                                     updateParametrosIntegracaoEmpresa()
                                } 
                            });
                       
                    }}             
                    label="Gravar" 
                    icon="pi pi-save"
                />
            </div>


            </div>
             <Toast ref={toast} />
        </Sidebar>
        </>
    );
}
